<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="审核状态" label-width="80px" v-if="$permission.hasAuth([1, 5])">
        <el-radio v-model="queryParam.agentAuditStatus">全部</el-radio>
        <el-radio v-model="queryParam.agentAuditStatus" :label="0">未审核</el-radio>
        <el-radio v-model="queryParam.agentAuditStatus" :label="1">已通过</el-radio>
        <el-radio v-model="queryParam.agentAuditStatus" :label="2">已驳回</el-radio>
      </el-form-item>
      <el-form-item label="审核状态" label-width="80px" v-if="$permission.hasAuth([4, 8, 3])">
        <el-radio v-model="queryParam.status">全部</el-radio>
        <el-radio v-model="queryParam.status" :label="false">未审核</el-radio>
        <el-radio v-model="queryParam.status" :label="true">已审核</el-radio>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>申请列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="shops" border>
      <el-table-column prop="companyName" label="门店名称"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="servicePhone" label="客服电话"></el-table-column>
      <el-table-column label="门店地址">
        <template #default="scope">
          {{scope.row.provinceName + (scope.row.cityName === scope.row.provinceName ? '' : scope.row.cityName) + scope.row.countyName}}{{scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column prop="agentCompanyName" label="服务商"></el-table-column>
      <el-table-column label="状态">
        <template #default="scope">
          {{scope.row.agentAuditStatus === 2 ? '已驳回' : scope.row.agentAuditStatus === 0 ? '待服务商审核' : !scope.row.status ? '待大区审核' : '已通过'}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([1, 5])" :disabled="scope.row.agentAuditStatus !== 0" @click="audit(scope.row, 1)">通过</el-link>
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([1, 5])" :disabled="scope.row.agentAuditStatus !== 0" @click="audit(scope.row, 2)">驳回</el-link>
          <el-link type="primary" href="javascript:;" v-if="$permission.hasAuth([4, 8, 3])" :disabled="scope.row.agentAuditStatus !== 1 || scope.row.status" @click="audit(scope.row)">通过</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>
</template>

<script>
export default {
  name: "门店审核",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {
        type: 0
      },
      shops: []
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.audit.list(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        this.shops = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    audit(shop, status) {
      if (!status) {
        this.$confirm('确认同意门店【' + shop.companyName + '】加入薛神驾到？', '审核确认',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }
        ).then(() => {
          this.$apis.audit.audit({userApplySn: shop.sn}).then(response => {
            if (response.status === 200) {
              this.$message({
                message: '审核成功',
                type: 'success'
              })
              this.list()
            }
          })
        }).catch(() => {

        })
      } else {
        this.$confirm('确认门店【' + shop.companyName + '】' + (status === 1 ? '已付款并通过' : '未付款并驳回') + '其申请？', '审核确认',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning'
            }
        ).then(() => {
          this.$apis.audit.agentAudit({userApplySn: shop.sn, agentSn: shop.agentSn, agentAuditStatus: status}).then(response => {
            if (response.status === 200) {
              this.$message({
                message: '审核成功',
                type: 'success'
              })
              this.list()
            }
          })
        }).catch(() => {

        })
      }
    }
  },
  created() {
    if (this.currentUser.type === 1) {
      this.queryParam.agentSn = this.currentUser.sn
    } else if (this.currentUser.type === 5) {
      this.queryParam.agentSn = this.currentUser.agentSn
    }
    this.list()
  }
}
</script>

<style scoped>

</style>